/**
 * Notification delivery settings — read by supervisors (to show the diverted
 * banner), changed by admins.
 */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type {
  NotificationSettings,
  NotificationSettingsUpdateInput,
} from '@vari-crew/schemas';
import { apiCall } from '@/lib/api';

const KEY = ['notification-settings'] as const;

export function useNotificationSettings(enabled = true) {
  return useQuery<NotificationSettings>({
    queryKey: KEY,
    queryFn: () => apiCall<NotificationSettings>('/notifications/settings'),
    enabled,
  });
}

export function useUpdateNotificationSettings() {
  const qc = useQueryClient();
  return useMutation<NotificationSettings, Error, NotificationSettingsUpdateInput>({
    mutationFn: (body) =>
      apiCall<NotificationSettings>('/notifications/settings', { method: 'PUT', body }),
    onSuccess: (res) => qc.setQueryData(KEY, res),
  });
}
